module.exports = __webpack_public_path__ + "static/media/ico-mach.0c305874.svg";